import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import SectionHeader from "@/components/shared/SectionHeader";
import { PROGRAMMES } from "@/lib/data";

const INCLUSIONS = [
  "Sessions and workshops",
  "Pedagogical materials",
  "Coffee breaks and lunches",
  "EISG certificate",
  "Practical tools and templates",
  "Access to EISG alumni / community",
];

const CARDS = [
  ...PROGRAMMES.map((p) => ({
    title: p.title.split("—")[0].trim(),
    sub: p.title.split("—")[1]?.trim() || p.short,
    location: p.location,
    duration: p.duration,
    price: p.price,
    unit: p.priceUnit,
    highlight: p.id === "command",
  })),
  {
    title: "EISG Advisory & In-House",
    sub: "Customised institutional support",
    location: "Across Africa",
    duration: "Sur mesure",
    price: "Sur devis",
    unit: "",
    highlight: false,
  },
];

const EISGInvestment = () => (
  <div>
    <section className="py-28 lg:py-36 bg-[#0A192F] text-white grain">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="overline text-[#D4AF37] mb-6">— Investment</div>
        <h1 className="font-eisg text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.02] max-w-5xl">
          Un investissement <span className="text-[#D4AF37] italic">stratégique</span> pour vous et votre organisation.
        </h1>
      </div>
    </section>

    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#0A192F]/10">
          {CARDS.map((c, i) => (
            <div
              key={c.title}
              className={`p-8 lift-card relative ${
                c.highlight ? "bg-[#0A192F] text-white" : "bg-white text-[#0A192F]"
              }`}
            >
              <div className={`section-num ${c.highlight ? "text-[#D4AF37]" : ""}`}>— {String(i + 1).padStart(2, "0")}</div>
              <h3 className={`mt-6 font-eisg text-2xl tracking-tight leading-tight ${c.highlight ? "text-white" : "text-[#0A192F]"}`}>
                {c.title}
              </h3>
              <div className={`mt-2 text-sm ${c.highlight ? "text-white/70" : "text-[#0A192F]/70"}`}>{c.sub}</div>
              <div className="mt-8 space-y-2 text-xs uppercase tracking-wider">
                <div className={c.highlight ? "text-white/60" : "text-[#0A192F]/60"}>{c.location}</div>
                <div className={c.highlight ? "text-white/60" : "text-[#0A192F]/60"}>{c.duration}</div>
              </div>
              <div className={`mt-6 pt-6 border-t ${c.highlight ? "border-white/20" : "border-[#0A192F]/15"}`}>
                <div className={`font-eisg text-3xl ${c.highlight ? "text-[#D4AF37]" : "text-[#0A192F]"}`}>{c.price}</div>
                {c.unit && <div className={`text-[11px] mt-1 ${c.highlight ? "text-white/55" : "text-[#0A192F]/55"}`}>{c.unit}</div>}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-20 grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <SectionHeader number="— 02" eyebrow="Inclus" title="Ce que comprend chaque programme EISG." titleFont="eisg" />
          </div>
          <div className="lg:col-span-7">
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4">
              {INCLUSIONS.map((inc) => (
                <li key={inc} className="flex items-start gap-3 text-[#0A192F]/80">
                  <Check size={18} className="text-[#D4AF37] mt-0.5 flex-shrink-0" />
                  <span className="font-bd">{inc}</span>
                </li>
              ))}
            </ul>
            <Link to="/eisg/registration" className="mt-10 inline-flex btn-premium btn-premium-primary">
              Réserver une place <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  </div>
);

export default EISGInvestment;
